<template>
  <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
    <v-toolbar dense :color="colorBarraFormulario" dark flat>
      <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
        <span v-bind:style="{ color: 'white' }">Etapa Extra</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-chip class="mr-4 px-10" label :color="colorAccent1" text-color="white" link @click="_guardarEtapa(true)">
        <span v-if="loading" v-bind:style="{ color: 'white' }">Creando...</span>
        <span v-else v-bind:style="{ color: 'white' }">Crear</span>
      </v-chip>
      <v-icon size="30" :color="'white'" @click="_cerrarVentana(null)">mdi-close-circle</v-icon>
    </v-toolbar>
    <v-card-text>
      <v-row class="mt-6" dense>


        
        <v-col class="ml-0">
          <v-row dense class="mx-4">
            <v-text-field v-model="modelEtapa.titulo" outlined label="Nombre de la Etapa" dense :dark="dark"
              autocomplete="off"></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-combobox outlined dense :dark="dark"
                                  autocomplete="off" label="Punto de Inicio" v-model="modelEtapa.inicio_punto"
                                  :items="puntos" item-text="nombre"
                                  item-value="id" return-object allow-input clearable
                                  :filter="customFilter"></v-combobox>
          </v-row>

          <v-row dense class="mx-4">
            <v-combobox outlined dense :dark="dark"
                                  autocomplete="off" label="Punto de llegada" v-model="modelEtapa.final_punto"
                                  :items="puntos" item-text="nombre"
                                  item-value="id" return-object allow-input clearable
                                  :filter="customFilter"></v-combobox>
          </v-row>

          
        <!--  <v-row dense class="mx-4">
            <v-select outlined dense :dark="dark" autocomplete="off" v-model="modelEtapa.inicio_punto" label="Inicio"
              :items="puntos" item-text="nombre" item-value="id" return-object></v-select>
          </v-row>

          <v-row dense class="mx-4">
            <v-select outlined dense :dark="dark" autocomplete="off" v-model="modelEtapa.final_punto" label="Final"
              :items="puntos" item-text="nombre" item-value="id" return-object></v-select>
          </v-row>-->

          <v-row dense class="mx-4">
            <v-select outlined dense :dark="dark" autocomplete="off" v-model="modelEtapa.dificultad" label="Dificultad"
              :items="['Fácil', 'Media', 'Difícil']"></v-select>
          </v-row>

          <v-row dense class="mx-4">
            <v-text-field outlined dense :dark="dark" autocomplete="off" v-model="modelEtapa.distancia"
              label="Distancia (Km)"></v-text-field>
          </v-row>

          <v-row dense class="mx-4">
            <v-text-field outlined dense :dark="dark" autocomplete="off" v-model="modelEtapa.duracion"
              label="Duración (Horas)"></v-text-field>
          </v-row>


        </v-col>
      </v-row>

    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "EtapaExtraFormulario",
  components: {},
  data: () => ({
    loading: false,
    tab: null,
    languages: ['Español', 'Inglés', 'Alemán'],

  }),

  props: {
    modelEtapa: {
      type: Object,
      required: true,
    },

    reserva_id: {
      type: Number,
      required: true,
    },

    fecha: {
      type: String,
      required: true,
    },

   
  },

  computed: {
    ...mapState([
      "drawer",
      "dark",
      "colorAccent1",
      "colorAccent2",
      "colorAccent3",
      "colorBarraFormulario",
      "colorFondoDialog",

    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
    ...mapState("puntos", ["puntos", "puntoSelec"]),
    ...mapState("categorias", ["categorias"]),

  },


  mounted() {
    this._getPuntos();
    
  },

  methods: {
    ...mapActions("etapas", ["getEtapas", "crearEtapaExtra", "updateEtapa"]),
    ...mapActions("categorias", ["getCategorias"]),
    ...mapActions("puntos", ["getPuntos"]),

    _cerrarVentana(reserva) {
      this._getPuntos();
  
      this.$emit("actualizarEtapaExtra", reserva);
    },

    async _getPuntos() {
      await this.getPuntos([this.access_token, false]);
    },

    onImageChange(event) {
      const file = event.srcElement.files[0]; // Aquí se recibe el archivo directamente
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;

          img.onload = () => {
            // Crear un canvas para recortar la imagen
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            const canvasSize = 200;
            canvas.width = canvasSize;
            canvas.height = canvasSize;

            // Calcular las dimensiones para el recorte centrado
            const scale = Math.max(
              canvas.width / img.naturalWidth,
              canvas.height / img.naturalHeight
            );

            const x = (canvas.width - img.naturalWidth * scale) / 2
            const y = (canvas.height - img.naturalHeight * scale) / 2
            const width = img.naturalWidth * scale
            const height = img.naturalHeight * scale

            // Limpiar el canvas y dibujar la imagen centrada
            ctx.fillStyle = '#FFFFFF'
            ctx.fillRect(0, 0, canvas.width, canvas.height)
            ctx.drawImage(img, x, y, width, height)

            this.modelEtapa.imagen_base64 = canvas.toDataURL('image/png');
          };

        };
        reader.readAsDataURL(file); // Lee el archivo como una URL de datos
      }
    },

    convertirImagen() {

    },

    customFilter(item, queryText, itemText) {
      const textOne = itemText.toLowerCase();
      const searchText = queryText.toLowerCase();

      return textOne.indexOf(searchText) > -1;
    },

    async _guardarEtapa(cerrar) {
      this.loading = true;
      let type = typeof this.modelEtapa.inicio_punto;
      if (this.modelEtapa.inicio_punto && type == 'object') {
        this.modelEtapa.inicio_punto_id = this.modelEtapa.inicio_punto.id;
      } 
      if (this.modelEtapa.inicio_punto && type == 'string') {
        this.modelEtapa.inicio_punto_nombre = this.modelEtapa.inicio_punto;
      }
      
      type = typeof this.modelEtapa.final_punto;
     
      if (this.modelEtapa.final_punto && type == 'object') {
        this.modelEtapa.final_punto_id = this.modelEtapa.final_punto.id;
      } 
      if (this.modelEtapa.final_punto && type == 'string') {
        this.modelEtapa.final_punto_nombre = this.modelEtapa.final_punto;
      }
      this.modelEtapa.reserva_id = this.reserva_id;
      this.modelEtapa.fecha = this.fecha;

       var res = await this.crearEtapaExtra([
          this.access_token,
          this.modelEtapa,
          this.reserva_id,
          this.fecha,
          
        ]);

        if (res) {
          this._cerrarVentana(res);
        }
      
      this.loading = false;
    },
  },
};
</script>
